import styled from 'styled-components'

export const RetryButtonElem = styled.div`
  display: flex;
  justify-content: center;
`
